/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { GetHistoryRes } from '../model/GetHistoryRes';
import { PutHistoryRes } from '../model/PutHistoryRes';
import { GetHistorytimestampRes } from '../model/GetHistorytimestampRes';
import { BaseRequestConfig } from '../../../framework/BaseRequestConfig';

export class HistoryApi {
    /**
     * Base Pathの設定。デフォルトは「/」
     */
    protected basePath: string = '/';

    /**
     * コンストラクタ
     * @param { ng.IHttpService } $http AngularJSのHTTPサービス
     * @param { function } $httpParamSerializer AngularJSのパラメータのシリアライザ
     * @param { string } basePath ベースパスを設定する
     */
    constructor(protected $http: ng.IHttpService, protected $httpParamSerializer?: ng.IHttpParamSerializer, basePath?: string) {
        if (basePath) {
            this.basePath = basePath;
        }
    }

    /**
     * 履歴一覧追加
     * 履歴のタイムスタンプ一覧を取得する。
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public historyGet(
                isDbl: boolean = false): ng.IHttpPromise<GetHistoryRes> {
        const path: string = this.basePath + '/history';

        let queryParameters: {[index: string]: any} = {};

        let httpRequestParams: BaseRequestConfig = {
            method: 'GET',
            url: path,
            params: queryParameters,
            unique: isDbl,
            screenId: path
        };
        return this.$http(httpRequestParams);
    }

    /**
     * 履歴追加
     * 画面復元用の履歴を格納する。
     * @param timestamp  タイムスタンプ
     * @param data  格納データ
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public historyPut(
                timestamp: string,
                data: string,
                isDbl: boolean = false): ng.IHttpPromise<PutHistoryRes> {
        const path: string = this.basePath + '/history';

        let queryParameters: {[index: string]: any} = {};
        let formParams: {[index: string]: any} = {};
        let headerParams: {[index: string]: any} = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };

        formParams['timestamp'] = timestamp;
        formParams['data'] = data;

        let httpRequestParams: BaseRequestConfig = {
            method: 'PUT',
            url: path,
            params: queryParameters,
            data: this.$httpParamSerializer(formParams),
            headers: headerParams,
            unique: isDbl,
            screenId: path
        };
        return this.$http(httpRequestParams);
    }

    /**
     * 履歴取得
     * 指定したタイムスタンプの履歴を取得する。
     * @param timestamp  タイムスタンプ
     * @param isDbl 2重送信の制御フラグ（true：2重送信を抑止、false：2重送信を許可）
     * @return Promiseを返す
     */
    public historyTimestampGet(
                timestamp: string,
                isDbl: boolean = false): ng.IHttpPromise<GetHistorytimestampRes> {
        const path: string = this.basePath + '/history/{timestamp}'
             .replace('{' + 'timestamp' + '}', String(timestamp));

        let queryParameters: {[index: string]: any} = {};

        let httpRequestParams: BaseRequestConfig = {
            method: 'GET',
            url: path,
            params: queryParameters,
            unique: isDbl,
            screenId: path
        };
        return this.$http(httpRequestParams);
    }

}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/history/api/HistoryApi.ts
 **/